<div class="DashmainContainer">
    <div class="container">
        <div class="col-lg-12">
            <section>
                <p>{{data.message}}</p>                
            </section>
        </div>
    </div>
</div>